import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { withNotificationContext } from "js/notification-context";
import AdminIdiomaNew from "./AdminIdiomaNew";
import styles from "./styles";

const enhance = compose(
  withApollo,
  withNotificationContext,
  withRouter,
  withStyles(styles)
);

export default enhance(AdminIdiomaNew);
